import { Backdrop, Box, Typography } from '@mui/material';

import Tooltip from '@/components/Tooltip';
import { useOverflowObserver } from '@/hooks/useOverflowObserver';

const Title = ({ title }: { title: string | React.ReactNode }) => {
  const [titleRef, isOverflowed] = useOverflowObserver<HTMLHeadingElement>([title]);
  if (typeof title === 'string' || typeof title === 'number') {
    return (
      <Tooltip
        title={isOverflowed ? title : ''}
        variant='secondary'
      >
        <Typography
          ref={titleRef}
          component='h1'
          sx={{
            flex: '1 1 auto',
            minWidth: 0,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
          }}
          variant='h2'
        >
          {title}
        </Typography>
      </Tooltip>
    );
  }
  return title;
};

export const DashboardLayout = ({
  title,
  children,
  renderRight,
  stickyHeader = false,
  isPending = false
}: {
  stickyHeader?: boolean;
  title: React.ReactNode;
  children?: React.ReactNode;
  renderRight?: React.ReactNode;
  isPending?: boolean;
}) => {
  return (
    <>
      <Box>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 3,
            py: 3,
            minWidth: 0,
            ...(stickyHeader
              ? {
                  position: 'sticky',
                  top: '-24px',
                  backgroundColor: 'background.default',
                  zIndex: 10
                }
              : {})
          }}
        >
          <Title title={title} />
          <Box sx={{ marginLeft: 'auto', flexShrink: 0 }}>{renderRight}</Box>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            gap: 3
          }}
        >
          {children}
        </Box>
      </Box>
      <Backdrop
        open={isPending}
        sx={{
          color: 'primary.main',
          zIndex: theme => theme.zIndex.drawer + 1,
          backgroundColor: 'rgba(0, 0, 0, 0.5)'
        }}
      />
    </>
  );
};
